import { render, staticRenderFns } from "./FAQItem.vue?vue&type=template&id=7bf54753&scoped=true&"
import script from "./FAQItem.vue?vue&type=script&lang=js&"
export * from "./FAQItem.vue?vue&type=script&lang=js&"
import style0 from "./FAQItem.vue?vue&type=style&index=0&id=7bf54753&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf54753",
  null
  
)

export default component.exports